import { createSelector } from "reselect";

import { RootState } from "../../state";

export const currentUserSelector = (state: RootState) => state.auth.currentUser;
export const currentCompanySelector = (state: RootState) => state.auth.currentCompany;
export const userSignedInSelector = createSelector(currentUserSelector, currentUser => !!currentUser);

export const countrySelector = (state: RootState) => state.auth.country;
export const localeSelector = (state: RootState) => state.auth.locale;

export const screenSizeSelector = (state: RootState) => state.media.screenSize;



// WEBPACK FOOTER //
// ./frontend/src/common/selectors/index.ts